module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"IssuerLogo":"Arbeitgeber Logo"},"en":{"IssuerLogo":"Issuer logo"}}')
  delete Component.options._Ctor
}
